<template>
    <div>
        <div class="col-md-12">
            <fieldset>
                <!--<div class="form-group">
                    <label>Bestellnummer</label>
                    <input type="text" class="form-control" name="po_number" v-model="po_number" @input="checkLength">
                </div>-->

                <div class="form-group">
                    <label>Anmerkungen</label>
                    <textarea class="form-control" name="remarks"></textarea>
                </div>
            </fieldset>
        </div>
        
        <!--<div class="col-md-12">
            <fieldset>
                <div class="form-group">
                    <label>EORI Nummer</label>
                    <input type="text" class="form-control" name="eori_number">
                </div>
                <div class="form-group">
                    <label>Telefonnummer der Kontaktperson bei der Lieferadresse</label>
                    <input type="text" class="form-control" name="phone_number">
                </div>
            </fieldset>
        </div>-->    
    </div>
</template>

<script>
export default {

    data() {
        return {
            po_number: null
        }
    },

    created() {
        this.qty = this.value;
        this.$emit('change', this.qty);
    },

    methods: {

        checkLength() {
            if(this.po_number.length > 35) {
                this.po_number = this.po_number.substr(0, 35);
            }
        }

    }


}
</script>